/**
 * Cart Drawer Touch Scrolling Fix
 * 
 * This script fixes touch scrolling issues in the cart drawer
 * when items are added or removed from the cart.
 */

document.addEventListener('DOMContentLoaded', () => {
  // Function to fix touch scrolling in cart drawer
  function fixCartDrawerTouchScrolling() {
    const cartDrawerContents = document.querySelector('#CartDrawer-CartItems');
    const scrollableWrapper = document.querySelector('.drawer__cart-items-wrapper');
    
    if (!cartDrawerContents || !scrollableWrapper) return;

    // Function to handle touch events properly
    function enableTouchScrolling(element) {
      // Remove any existing touch event listeners first
      element.removeEventListener('touchstart', handleTouchStart);
      element.removeEventListener('touchmove', handleTouchMove);
      
      // Add touch event listeners
      element.addEventListener('touchstart', handleTouchStart, { passive: true });
      element.addEventListener('touchmove', handleTouchMove, { passive: false });
      
      // Store the initial touch position
      let startY;
      
      function handleTouchStart(e) {
        startY = e.touches[0].clientY;
      }
      
      function handleTouchMove(e) {
        if (!startY) return;
        
        const currentY = e.touches[0].clientY;
        const scrollTop = element.scrollTop;
        const scrollHeight = element.scrollHeight;
        const clientHeight = element.clientHeight;
        
        // Determine if we should prevent default scrolling behavior
        // Allow scrolling if not at the top or bottom boundaries
        if ((scrollTop <= 0 && currentY > startY) || 
            (scrollTop + clientHeight >= scrollHeight && currentY < startY)) {
          // At the boundary and trying to scroll beyond it - prevent default
          e.preventDefault();
        }
        
        // Otherwise, allow the default scroll behavior
      }
    }
    
    // Apply touch scrolling fix to the scrollable container
    enableTouchScrolling(scrollableWrapper);
    
    // Re-apply the fix after cart updates
    function reapplyTouchScrollingFix() {
      setTimeout(() => {
        const updatedScrollableWrapper = document.querySelector('.drawer__cart-items-wrapper');
        if (updatedScrollableWrapper) {
          enableTouchScrolling(updatedScrollableWrapper);
        }
      }, 100);
    }
    
    // Watch for cart updates by observing the cart drawer contents
    const cartObserver = new MutationObserver(reapplyTouchScrollingFix);
    cartObserver.observe(cartDrawerContents, { 
      childList: true, 
      subtree: true 
    });
    
    // Also listen for cart form submissions
    document.addEventListener('submit', (e) => {
      if (e.target && e.target.action && e.target.action.includes('/cart/')) {
        reapplyTouchScrollingFix();
      }
    });
    
    // Listen for quantity changes
    document.addEventListener('change', (e) => {
      if (e.target && e.target.classList.contains('quantity__input')) {
        reapplyTouchScrollingFix();
      }
    });
    
    // Listen for cart item removal
    document.addEventListener('click', (e) => {
      if (e.target && e.target.closest('.cart-remove-custom-button')) {
        reapplyTouchScrollingFix();
      }
    });
  }

  // Initialize the fix
  fixCartDrawerTouchScrolling();
  
  // Re-initialize after any cart drawer opening
  document.addEventListener('click', (e) => {
    if (e.target && e.target.closest('#cart-icon-bubble')) {
      setTimeout(fixCartDrawerTouchScrolling, 300);
    }
  });
});
